var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFacebookNav = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5533 13.7848C11.5082 13.7848 10.5153 13.7848 10.064 13.7848C9.82327 13.7848 9.74805 13.6945 9.74805 13.4689C9.74805 12.8671 9.74805 12.2503 9.74805 11.6486C9.74805 11.4078 9.83831 11.3326 10.064 11.3326H11.5533C11.5533 11.2875 11.5533 10.415 11.5533 10.0088C11.5533 9.40702 11.6586 8.83535 11.9595 8.30882C12.2754 7.76724 12.7267 7.40618 13.2984 7.19557C13.6745 7.06018 14.0506 7 14.4568 7H15.9311C16.1417 7 16.2319 7.09026 16.2319 7.30088V9.01588C16.2319 9.22649 16.1417 9.31675 15.9311 9.31675C15.5249 9.31675 15.1187 9.31675 14.7125 9.3318C14.3063 9.3318 14.0957 9.52737 14.0957 9.9486C14.0807 10.3999 14.0957 10.8362 14.0957 11.3025H15.8408C16.0815 11.3025 16.1718 11.3928 16.1718 11.6335V13.4538C16.1718 13.6945 16.0966 13.7697 15.8408 13.7697C15.2992 13.7697 14.1409 13.7697 14.0957 13.7697V18.674C14.0957 18.9298 14.0205 19.02 13.7497 19.02C13.1179 19.02 12.5011 19.02 11.8692 19.02C11.6436 19.02 11.5533 18.9298 11.5533 18.7041C11.5533 17.1245 11.5533 13.8299 11.5533 13.7848Z",
    fill: "#00AAE5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.7,
    width: 24.6,
    height: 24.6,
    rx: 5.8,
    stroke: "#00AAE5",
    strokeWidth: 1.4
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookNav, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook-nav.624a1638.svg";
export { ForwardRef as ReactComponent };